<template>
  <button
    class="icon-button"
    :type="type"
  >
    <slot /></button>
</template>

<script>
export default {
  name: "heim-icon-button",
  props: {
    type: {
      type: String,
      default: "button"
    }
  }
};
</script>

<style scoped>
button.icon-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
  border-radius: 60px;
  width: 38px;
  height: 28px;
}
button.icon-button:hover,
button.icon-button:focus {
  box-shadow: var(--heim-shadow);
}
</style>
